import React from 'react';
import {
  Ban,
  CircleAlert,
  Clock,
  Send,
  Mail,
  CheckCircle2,
  LucideIcon,
} from 'lucide-react';
import {
  BenefitsState,
  BENEFITS_STATE_DISPLAY,
  BenefitsStateDisplay,
  benefitsStateLabel,
  benefitsNoteTitle,
} from './benefitsStatus';

const ICONS: Record<BenefitsStateDisplay['icon'], LucideIcon> = {
  ban: Ban,
  alert: CircleAlert,
  clock: Clock,
  send: Send,
  mail: Mail,
  check: CheckCircle2,
};

// The single unified benefits status badge, shared across the funeral sidebar,
// the board column, and the mobile list. Icon + small colored pill, matching
// the SidebarStatusBadge visual language.
export function BenefitsStatusBadge({
  state,
  benefitsType,
  size = 'md',
  note,
}: {
  state: BenefitsState;
  benefitsType?: 'cpp' | 'qpp';
  size?: 'sm' | 'md';
  // Ineligible reason / confirmation number, shown on hover.
  note?: string | null;
}) {
  const display = BENEFITS_STATE_DISPLAY[state];
  const Icon = ICONS[display.icon];
  const iconSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const textSize = size === 'sm' ? 'text-[9px]' : 'text-[10px]';
  return (
    <span
      className="inline-flex items-center gap-1.5"
      title={note ? benefitsNoteTitle(state, note) : undefined}
    >
      <Icon className={`${iconSize} ${display.iconClass}`} aria-hidden={true} />
      <span
        className={`${textSize} font-medium px-1.5 py-0.5 rounded ${display.chipClass}`}
      >
        {benefitsStateLabel(state, benefitsType)}
      </span>
    </span>
  );
}

export default BenefitsStatusBadge;
